import { render, staticRenderFns } from "./Anagrafiche.vue?vue&type=template&id=55ad7ba6&scoped=true&"
import script from "./Anagrafiche.vue?vue&type=script&lang=js&"
export * from "./Anagrafiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad7ba6",
  null
  
)

export default component.exports